var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nation-map-wrapper",attrs:{"id":_vm.wrapperId}},[(_vm.loading)?_c('loading',{staticClass:"map-loading-overlay",attrs:{"color":"#333","loading":_vm.loading,"text":"Loading Models"}}):_vm._e(),_c('div',{staticClass:"nationwide-map",attrs:{"id":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }